<div class="db-ai-builder-pages-table-row pages {{page?.id}}"
     [ngClass]="{'slide-tab': slidesTab}">
  <div class="title">
    <span class="mr10 page_type" [ngClass]="{'front_page': page?.frontPage}" *ngIf="pagesTab"
          [dsTooltip]="page?.frontPage ? 'Front page' : ''"
          dsTooltipPosition="bottom" dsTooltipAlign="left" dsTooltipSize="small" dsTooltipColor="black"></span>
    <a class="db-page-title" [href]="page?.link" target="_blank" rel="noopener" [innerHTML]="page?.title" [dsTooltipPosition]="'bottom'"
          [dsTooltipAlign]="'right'"
          [dsTooltipVisible]="page?.title.length > 33"
          [dsTooltip]="'<span style=\'font-weight: 600; color: #323A4580\'>Title</span><br><span style=\'font-weight: 600; display: block; max-width: 500px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;\'>' + page?.title + '</span>'"></a>
    <div class="recreated"
         *ngIf="page?.templateType && (page?.createdWith === 'twbb_recreated' || page?.createdWith === 'twbb_generated') && !!showCreatedWithAiBtn && pagesTab"
         [dsTooltip]="'Created with 10Web AI Builder'"
         dsTooltipPosition="bottom" dsTooltipAlign="left" dsTooltipSize="small" dsTooltipColor="black">AI</div>
  </div>
  <a class="pageLink" *ngIf="page?.link && pagesTab"
     [href]="page?.link" target="_blank" rel="noopener"
     [innerHTML]="page?.frontPage ? (demoUser ? '../home/' : page?.link) : (page?.link | trimHomeUrl :  websiteHomeUrl)"
     [dsTooltipPosition]="'bottom'" [dsTooltipAlign]="'left'" [dsTooltipVisible]="page?.link.length > 33"
     [dsTooltip]="'<span style=\'font-weight: 600; color: #323A4580\'>URL</span><br><span style=\'font-weight: 600; display: block; max-width: 500px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden\'>' + page?.link + '</span>'"></a>
  <span *ngIf="!pagesTab && !slidesTab"
        [innerHTML]="page?.conditionCount + ' Condition' + (page?.conditionCount > 1 ? 's' : '')"></span>
  <span *ngIf="!isMobile && page && page.modifiedDate" [innerHTML]="page?.modifiedDate | date: 'yyyy-MM-dd hh:mm:ss'"></span>
  <ds-dropdown *ngIf="!isMobile" [formControl]="status"
               [dsDropdownOptions]="statusOptions" [dsDropdownWidth]="'120px'"
               [value]="status?.value"
               (onOptionChoose)="statusChange($event, page)"></ds-dropdown>
  <ng-container>
    <a *ngIf="paidClient" dbWpLink
       (click)="handleEditClick()" [adminLink]="websiteAdminUrl +
  '/post.php?post=' + page?.id +
  '&action=elementor'"
       [websiteId]="websiteId"
       target="_blank" rel="noopener" [ngClass]="{'ds-btn-medium ds-btn db-edit-button': isMobile}">
      <i class="db-icon db-icon-ds-edit-box" *ngIf="!isMobile"></i>
      <span *ngIf="isMobile">Edit page</span>
    </a>
    <a *ngIf="!paidClient"
       (click)="showCheckoutUpgradeDialog()"
       [ngClass]="{'ds-btn-medium ds-btn db-edit-button': isMobile}">
      <i class="db-icon db-icon-ds-edit-box" *ngIf="!isMobile"></i>
      <span *ngIf="isMobile">Edit page</span>
    </a>
  </ng-container>
  <a *ngIf="!isMobile" [dsTooltip]="actionsRef" dsTooltipMode="click" dsTooltipAlign="right" dsTooltipSize="small">
    <i class="db-icon db-icon-ds-more-l"></i>
  </a>

  <ng-template #actionsRef>
    <div class="db-ai-builder-page-item__actions">
      <p class="mb7" *ngIf="!page?.frontPage && page?.pageStatus != 'draft' && !!pagesTab"
         (click)="showNotificationDialog(page?.id, 'setFrontPage', page?.pageStatus)"
         [innerHTML]="'Set Frontpage'"></p>
      <p (click)="showNotificationDialog(page?.id, 'remove', page?.pageStatus)" [innerHTML]="'Remove Page'"></p>
    </div>
  </ng-template>
</div>
